import { useQuery } from "@tanstack/react-query";
import { getHome } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook لجلب بيانات الصفحة الرئيسية
 * Returns home sections (hero banners, featured products, etc.)
 */
export function useGetHome() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["home", i18next.language],
        queryFn: () => getHome(),
        retry: false,
        staleTime: 1000 * 60 * 60, // Cache for 1 hour as per API documentation
    });

    const homeData = data?.data?.data || null;

    return { isLoading, error, homeData, refetch };
}
